export default __webpack_public_path__ + "static/media/480_dummy2016-wellness01-de.f0a19ccd.png";